import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppSettingsService } from '../../appsettings/appsettings.service';

@Injectable()
export class ReportingService
{	
	readonly rootUrl = environment.ProNetApiRootUrl; // 'http://localhost:3001';
	
	constructor(private httpClient: HttpClient, private router: Router, env: AppSettingsService) { 
		this.rootUrl = env.config.ProNetApiRootUrl; }
		
	getRecentTestOrders(nDays) : Observable<any>{
		console.log("getting recent test orders");

		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json',
		});

		return this.httpClient.get(`${this.rootUrl}/api/testorder/recent/${nDays}`, {headers: headers});
	}

	getTestOrderGroups() : Observable<any>{
		return this.httpClient.get(`${this.rootUrl}/api/testorder/testgroups`);
	}

	getTestList() : Observable<any>{
		return this.httpClient.get(`${this.rootUrl}/api/testorder/tests`);
	}
	
	searchTestOrders(fromDate, toDate, testGroupId) : Observable<any>{
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json',
		});

		const body = {
			fromDate: fromDate, 
			toDate: toDate,
			testGroupId: testGroupId
		};

		return this.httpClient.post(`${this.rootUrl}/api/testorder/search`, body, {headers: headers});
	}

	getPatientTests(patientId): Observable<any>{
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json',
		});

		return this.httpClient.get(`${this.rootUrl}/api/testorder/getpatient/${patientId}`, {headers: headers});
	}

	getReport(orderTestId, orderEntityId) : Observable<any>{
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json',
		});

		return this.httpClient.get(`${this.rootUrl}/api/report/${orderTestId}/${orderEntityId}`, {headers: headers, responseType: 'blob' });
	}

	getSummaryReport(fromDate, toDate, catalogNumber, sortBy) : Observable<any>{
		const headers = new HttpHeaders(
		{
			'No-Auth':'False',
			'Content-Type': 'application/json',
		});

		const body = {
			fromDate: fromDate, 
			toDate: toDate,
			catalogNumber: catalogNumber,
			sortBy: sortBy
		};

		return this.httpClient.post(`${this.rootUrl}/api/report/summary`, body, {headers: headers, responseType: 'blob' });
	}
}
